import { NUMBER_SIZE } from '../../constants/size'

export const BUTTON_HEIGHT_16 = NUMBER_SIZE.size16

export const BUTTON_HEIGHT_20 = NUMBER_SIZE.size20

export const BUTTON_HEIGHT_24 = NUMBER_SIZE.size24

export const BUTTON_HEIGHT_32 = NUMBER_SIZE.size32

export const BUTTON_HEIGHT_40 = NUMBER_SIZE.size40

export const BUTTON_HEIGHT_48 = NUMBER_SIZE.size48

export const BUTTON_CLASS_ALIASES = {
  [BUTTON_HEIGHT_20]: 'size20',
  [BUTTON_HEIGHT_24]: 'size24',
  [BUTTON_HEIGHT_32]: 'size32',
  [BUTTON_HEIGHT_40]: 'size40',
  [BUTTON_HEIGHT_48]: 'size48',
}

export const BUTTON_INLINE_CLASS_ALIASES = {
  [BUTTON_HEIGHT_16]: 'inlineSize16',
  [BUTTON_HEIGHT_24]: 'inlineSize24',
}

export const BUTTON_SQUARE_CLASS_ALIASES = {
  [BUTTON_HEIGHT_16]: 'squareSize16',
  [BUTTON_HEIGHT_20]: 'squareSize20',
  [BUTTON_HEIGHT_24]: 'squareSize24',
  [BUTTON_HEIGHT_32]: 'squareSize32',
  [BUTTON_HEIGHT_40]: 'squareSize40',
  [BUTTON_HEIGHT_48]: 'squareSize48',
}

export const ButtonType = {
  Button: 'button',
  Submit: 'submit',
}
